"use strict";

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initRules = void 0;

var utils_1 = require("../utils");

function initRules(rules, config, type, oasVersion) {
  return rules.flatMap(function (ruleset) {
    return Object.keys(ruleset).map(function (ruleId) {
      var rule = ruleset[ruleId];
      var ruleSettings = type === 'rules' ? config.getRuleSettings(ruleId, oasVersion) : type === 'preprocessors' ? config.getPreprocessorSettings(ruleId, oasVersion) : config.getDecoratorSettings(ruleId, oasVersion);

      if (ruleSettings.severity === 'off') {
        return undefined;
      }

      var visitors = rule(ruleSettings);

      if (Array.isArray(visitors)) {
        return visitors.map(function (visitor) {
          return {
            severity: ruleSettings.severity,
            ruleId: ruleId,
            visitor: visitor
          };
        });
      }

      return {
        severity: ruleSettings.severity,
        ruleId: ruleId,
        visitor: visitors // note: actually it is only one visitor object

      };
    });
  }).flatMap(function (visitor) {
    return visitor;
  }).filter(utils_1.isDefined);
}

exports.initRules = initRules;